/**
 * Calculate the percentual difference between the currentValue and the nextValue
 */
export function calculateLossRate(currentValue: number, nextValue: number): number {
  const MAX_COVERAGE_PERCENTAGE = 100;

  const nextValuePercentage = Math.floor((nextValue * MAX_COVERAGE_PERCENTAGE) / currentValue);

  return Math.max(0, MAX_COVERAGE_PERCENTAGE - nextValuePercentage);
}
